import { useCallback, useEffect } from "react";

const useSelectionEffects = (
  nodes,
  setNodes,
  edges,
  setEdges,
  selectedEdge,
  setSelectedEdge
) => {
  const onEdgeClick = useCallback(
    (event, edge) => {
      setSelectedEdge(edge);

      setEdges((prevEdges) =>
        prevEdges.map((e) => {
          const isSelected = e.id === edge.id;
          const isConnected =
            e.source === edge.source && e.target === edge.target;

          return {
            ...e,
            zIndex:
              e.id === edge.id ||
              e.source === edge.source ||
              e.target === edge.target
                ? 100
                : e.zIndex,
            style: {
              ...e.style,
              stroke: isSelected || isConnected ? e.originalColor : "gray",
              strokeWidth: isSelected ? 3 : 2,
              opacity: isSelected || isConnected ? 1 : 0.3,
            },
            animated: isSelected,
          };
        })
      );

      setNodes((prevNodes) =>
        prevNodes.map((n) => {
          const isConnected = n.id === edge.source || n.id === edge.target;

          return {
            ...n,
            zIndex:
              n.id === edge.source || n.id === edge.target ? 100 : n.zIndex,
            style: {
              ...n.style,
              opacity: isConnected ? 1 : 0.3,
            },
          };
        })
      );
    },
    [setEdges, setNodes, setSelectedEdge]
  );

  const onPaneClick = useCallback(
    (event, panelRef) => {
      if (selectedEdge) {
        setSelectedEdge(null);
      }
    },
    [selectedEdge, setSelectedEdge]
  );

  useEffect(() => {
    if (!selectedEdge) {
      setEdges((prevEdges) =>
        prevEdges.map((e) => ({
          ...e,
          style: {
            ...e.style,
            stroke: e.originalColor,
            strokeWidth: 2,
            opacity: 1,
          },
          animated: false,
          zIndex: undefined,
        }))
      );

      setNodes((prevNodes) =>
        prevNodes.map((n) => ({
          ...n,
          style: {
            ...n.style,
            opacity: 1,
          },
          zIndex: undefined,
        }))
      );
    }
  }, [selectedEdge, setEdges, setNodes]);

  return {
    onEdgeClick,
    onPaneClick,
  };
};

export default useSelectionEffects;
